import * as types from '../actions';

export default function(state = [], action) {
  const response = action.response;
  let timeVar = '~~'+Date.now(); 

  switch(action.type) {    

    case types.LOGIN_USER_SUCCESS:
      return { ...state, 
        loginActivity: types.LOGIN_USER_SUCCESS,
        response };
    case types.LOGIN_USER_ERROR:
      return { ...state, 
        loginActivity: types.LOGIN_USER_ERROR,
        response };


    case types.LOGIN_CLIENT_AFFILIATE_LIST_SUCCESS:
      if(response.status===200){
        return { ...state, 
          loginAffiliateActivity: types.LOGIN_CLIENT_AFFILIATE_LIST_SUCCESS,
          response };
      }
      else {
        return { ...state, 
          loginAffiliateActivity: types.LOGIN_CLIENT_AFFILIATE_LIST_ERROR,
          response };
      }
    case types.LOGIN_CLIENT_AFFILIATE_LIST_ERROR:
      return { ...state, 
        loginAffiliateActivity: types.LOGIN_CLIENT_AFFILIATE_LIST_ERROR,
        response };

        
    case types.FORGOT_PASSWORD_SUCCESS:
      let forgotPwdResponse = response; 
      return { ...state, 
        forgotPwdActivity: types.FORGOT_PASSWORD_SUCCESS+timeVar,
        forgotPwdResponse };
    case types.FORGOT_PASSWORD_ERROR:
      return { ...state, 
        forgotPwdActivity: types.FORGOT_PASSWORD_ERROR+timeVar, 
        forgotPwdResponse };
    
    case types.CLEAR:
        return {
            ...state, 
            loginActivity:'',
    }  

    default:
      return state;
  }
};